import { getSelectedLanguage } from '@frontend/translate';
import { useAbortableFetch } from '@frontend/utils/hooks/useAbortableFetch';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { Button } from '../common';

export function TakeRequestButton(props: { reloadProcess: () => Promise<void>; request: IRequestGetOne }) {
    const language = getSelectedLanguage();
    const abortableFetch = useAbortableFetch();

    if (
        !props.request.authorization ||
        !props.request.authorization.canTakeProcessFromColleague ||
        !props.request.recipientPractitionerId
    ) {
        return null;
    }

    return (
        <Button
            color="secondary"
            large
            onClick={async () => {
                const url = `/api/requests/${props.request.id}/takeProcessFromColleague`;
                await abortableFetch.fetchJson(url, 'POST');
                await props.reloadProcess();
            }}
            outlined
        >
            {language.request.statusAction_takeFromColleague}
        </Button>
    );
}
